import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ImageGalleryIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ImageGallery",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M25.84 8.13H12.65c-2.3 0-4.16 1.86-4.16 4.16v13.88c0 2.3 1.86 4.16 4.16 4.16h13.19c2.3 0 4.16-1.86 4.16-4.16V12.29c0-2.3-1.86-4.16-4.16-4.16m1.39 18.04c0 .77-.62 1.39-1.39 1.39H12.65c-.77 0-1.39-.62-1.39-1.39V12.29c0-.77.62-1.39 1.39-1.39h13.19c.77 0 1.39.62 1.39 1.39zm-2.5-7.88a1.02 1.02 0 0 0-1.13.27s-4.1 4.77-4.1 4.77c-.06.07-.16.12-.26.12-.06 0-.11-.01-.16-.04s-2.02-2.24-2.02-2.24c-.17-.13-.39-.21-.63-.21-.05 0-.11 0-.16.01-.27.04-.51.19-.66.39s-2.3 2.71-2.3 2.71c-.13.17-.2.38-.2.61 0 .57.46 1.03 1.03 1.03h10.19c.57 0 1.03-.46 1.03-1.03v-5.45c0-.42-.26-.79-.62-.94Zm-7.92-3.68c0 1.02-.83 1.85-1.85 1.85s-1.85-.83-1.85-1.85.83-1.85 1.85-1.85 1.85.83 1.85 1.85m3.7-9.72c0-.26-.21-.46-.46-.46H5.24c-.26 0-.46.21-.46.46v15.73c0 .26.21.46.46.46.77 0 1.39.62 1.39 1.39s-.62 1.39-1.39 1.39A3.24 3.24 0 0 1 2 20.62V4.9a3.24 3.24 0 0 1 3.24-3.24h14.81a3.24 3.24 0 0 1 3.24 3.24c0 .77-.62 1.39-1.39 1.39s-1.39-.62-1.39-1.39Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M25.86 29.29h-16c-1.89 0-3.43-1.54-3.43-3.43v-16c0-1.89 1.54-3.43 3.43-3.43h16c1.89 0 3.43 1.54 3.43 3.43v16c0 1.89-1.54 3.43-3.43 3.43m-16-20.58c-.63 0-1.14.51-1.14 1.14v16c0 .63.51 1.14 1.14 1.14h16c.63 0 1.14-.51 1.14-1.14v-16c0-.63-.51-1.14-1.14-1.14z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M3 23.06c-.63 0-1.14-.51-1.14-1.14V5.29c0-1.89 1.54-3.43 3.43-3.43h16.63a1.14 1.14 0 1 1 0 2.28H5.29c-.63 0-1.14.51-1.14 1.14v16.63c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "13.92",
        cy: "13.92",
        r: ".64"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.92 15.7c-.98 0-1.78-.8-1.78-1.78s.8-1.78 1.78-1.78 1.78.8 1.78 1.78-.8 1.78-1.78 1.78m0-2.29c-.28 0-.51.23-.51.51s.23.51.51.51.51-.23.51-.51-.23-.51-.51-.51M13.29 24.71c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l5.24-5.24c1.3-1.29 3.55-1.3 4.85 0l1.81 1.81c.45.45.45 1.17 0 1.62s-1.17.45-1.62 0l-1.81-1.81c-.43-.43-1.19-.43-1.62 0l-5.24 5.24c-.22.22-.52.33-.81.33Z"
      })]
    })
  }));
};
ImageGalleryIcon.displayName = 'ImageGalleryIcon';